import React from 'react';
import {
  FDTitleText, FDBodyText, FDStack, FDAlert,
} from '@facet-wealth/design';

export const Contribution = ({ resource }) => {
  const alertDesc = resource.attr('alertDescription');

  return (
    <FDStack direction={'column'} spacing={1}>
      {resource.attr('title') && <FDTitleText value={resource.attr('title')} size={'md'} />}
      {alertDesc === '' && (
        <FDStack direction={'row'} spacing={2}>
          <FDStack direction={'column'} minWidth={'114px'}>
            <FDTitleText size={'md'} value={resource.attr('contributionLimitLabel')} />
            <FDBodyText size={'md'} value={resource.attr('contributionLimit')} />
          </FDStack>
          <FDStack direction={'column'}>
            <FDTitleText size={'md'} value={resource.attr('catchUpLabel')} />
            <FDBodyText size={'md'} value={resource.attr('catchUpAmount')} />
          </FDStack>
        </FDStack>
      )}
      {alertDesc !== '' && (
        <FDAlert
          title={resource.attr('alertHeading')}
          description={alertDesc}
          status={'warning'}
        />
      )}
    </FDStack>
  );
};
